import React from 'react';
import SubmitButton from 'packages/smart-home-support/pages/signup/components/SubmitButton';

export default (props) => <SubmitButton {...props} />;



// WEBPACK FOOTER //
// ./packages/smart-home-support/assets/components/ConfirmationCallButton.tsx